'use client'

import { IVidyardPlayerProps } from '@/utils/types'
import Image from 'next/image'
import { useEffect } from 'react'

const VIDYARD_SCRIPT_SRC = 'https://play.vidyard.com/embed/v4.js'
const VIDYARD_SCRIPT_ID = 'vidyard-embed-script'

declare global {
  interface Window {
    VidyardV4?: {
      api: {
        renderDOMPlayers: () => void
      }
    }
  }
}

const VidyardPlayer = ({
  className,
  videoId,
  controls = '0',
  autoplay = '1',
  aspect,
  height,
  width,
}: IVidyardPlayerProps): React.ReactElement => {
  useEffect(() => {
    if (window.VidyardV4) {
      window.VidyardV4.api.renderDOMPlayers()
      return
    }

    if (document.getElementById(VIDYARD_SCRIPT_ID)) return

    const script = document.createElement('script')
    script.id = VIDYARD_SCRIPT_ID
    script.src = VIDYARD_SCRIPT_SRC
    script.async = true
    script.onload = () => window.VidyardV4?.api.renderDOMPlayers()
    document.body.appendChild(script)
  }, [videoId])

  return (
    <div className={className ?? 'relative mx-auto w-full *:rounded-md'}>
      <Image
        className="vidyard-player-embed"
        src={`https://play.vidyard.com/${videoId}.jpg`}
        data-uuid={videoId}
        data-v="4"
        data-type="inline"
        data-hidden_controls={controls}
        data-autoplay={autoplay}
        data-aspect={aspect}
        height={height as number}
        width={width as number}
        alt="Vidyard video player"
        data-quality="1080p"
        style={{ width: '100%', margin: 'auto', display: 'block' }}
      />
    </div>
  )
}

export default VidyardPlayer
